@if (isPetDocument) {
<img [src]="thumbnail" class="d-block p-30 ml-auto mr-auto" />
}@else {
<iframe src="" width="100%" height="1000px" id="myFrame"> </iframe>
}